import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { NewButton, SaveButton } from "../../../components/Buttons";

export const Customer = () => {
    document.title = "Tərəf müqabil";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Tərəf müqabillər", value: "/customers" },
        { name: "Tərəf müqabil", value: "/customers/customer", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Tərəf müqabil</h2>
                    <p>
                        İstifadəçinin müştəriləri, məhsul aldığı təchizatçılar, əməkdaşlar və s. qeydiyyata almaq üçün nəzərdə tutulub. Yeni tərəf müqabil
                        yaratmaq üçün nümunəyə uyğun ardıcıllığı icra etmək lazımdır. <NewButton>Yeni müştəri</NewButton> düyməsini sıxıb açılan pəncərədə ad,
                        qrup, təyin edib <SaveButton /> düyməsini sıxmaq lazımdır. Tərəf müqabillər səhifəsində müştərinin <b>bonus hesabı</b>, təyin olunmuş{" "}
                        <b>endirimi</b> əks olunur.
                    </p>
                    <img src="/images/customers/customer-1.gif" alt="Tərəf müqabil" />
                    <h2>Qruplar</h2>
                    <p>
                        Müştəriləri qruplaşdırmaq üçün <NewButton>Yeni qrup</NewButton> düyməsini sıxıb açılan pəncərədə qrup adını təyin edib <SaveButton />{" "}
                        düyməsini sıxmaq lazımdır.
                    </p>
                    <img src="/images/customers/customer-2.gif" alt="Tərəf müqabil" />
                </article>
            </div>
        </div>
    );
};
